import script from "./MobileTabBar2.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileTabBar2.vue?vue&type=script&setup=true&lang=js"

import "./MobileTabBar2.vue?vue&type=style&index=0&id=4bb41efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb41efe"]])

export default __exports__